import { CSSObject} from "styled-components";

interface GridStyles {
    gridContainer: CSSObject;
}
const useGridStyles = (gridHeight: number): GridStyles => {
    
    return {
        gridContainer: {
            width: "100%",
           /* height: gridHeight * 0.7,*/
        },
    };
};
export default useGridStyles;
